import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { FreemiumWatchlistComponent } from './freemium-watchlist.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { DropdownsModule } from '../../dropdowns/dropdowns.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { routing, appRoutingProviders } from './freemium-watchlist.routing.';
import { AppListViewModule } from '../../app-list-view/app-list-view.module';

@NgModule({
  declarations: [
    FreemiumWatchlistComponent,
  ],
  imports: [
    DirectivesModule,
    PipesModule,
    DropdownsModule,
    AppListViewModule,
    CommonModule,
    FormsModule,
    routing,
  ],
  providers: [
    appRoutingProviders
  ]
})
export class FreemiumWatchlistModule { }
